import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import BackToTopButton from './BackToTopButton';

export default function Faq({data} :any) {

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">FAQ</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body col-lg-9 col-md-4">
              <div className="faq-section">
                <div className="container-fluid bg-gradient-success py-2">
                  <p className="mb-0 text-white">Investing</p>
                </div>
                <div className="accordion">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        <strong>What is Decode Investing?</strong>
                      </h5>
                    </div>
                    <div id="collapseOne" className="collapse show">
                      <div className="card-body">
                        <p>
                          Decode investing is a set of tools that help investors discover opportunities and identify risks in the stock market.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h5 className="mb-0">
                        <strong>Why did you build Decode Investing?</strong>
                      </h5>
                    </div>
                    <div id="collapseThree" className="collapse show">
                      <div className="card-body">
                        <p>
                          Value investing is a form of investing used by some of the most successful investors in the world, but there is a lack of mainstream adoption of value investing.
                          It is simple in concept but difficult to put into practice. I wanted to help make value investing more accessible to the average investor.
                        </p>
                        <p>
                          <a href="https://www.youtube.com/channel/UCA8P3Rgfjn0IFZL4bmrKbrg">Phil Town</a> started a movement with <a href='https://www.amazon.com/Rule-Strategy-Successful-Investing-Minutes/dp/0307336840/'>Rule One Investing</a>, he made value investing approachable and practical, he put it in a way that anyone can learn and apply it successfully.
                          A problem I noticed is that there is a lack of modern software tools for Value Investing.
                          Most existing tools have not kept up with advancements in technology and software development.
                        </p>
                        <p>
                          I want to help pass on this amazing principle and strategy called Value Investing to a new generation of Investors.
                          I want to use the best technologies available today to build the best modern software tools for the next generation of value investors.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <strong>Are you an Investment Education company?</strong>
                      </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show">
                      <div className="card-body">
                        <p>
                          No, we are a software company, our first goal is to build great software tools that make it easy for anyone to apply sound investing principles and make great investment returns.
                          Our product is still in a very early beta version, but we are iterating very fast and making improvements.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <strong>What resources do you recommend to learn more about modern value investing?</strong>
                      </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show">
                      <div className="card-body">
                        I wrote this small introduction to value investing <a href="https://decode-investing.medium.com/how-to-make-higher-returns-in-the-stock-market-in-a-safe-and-predictable-way-cd51bb8bc5c9">How to make impressive returns from the stock market</a>.
                        I also recommend these 3 books for an introduction and practical guide to Value Investing, <a href="https://www.amazon.com/Rule-Strategy-Successful-Investing-Minutes/dp/0307336840/">Rule #1 by Phil Town</a>, <a href="https://www.amazon.com/Payback-Time-Outsmarting-Getting-Investments/dp/1847940641/">Payback Time by Phil Town</a>,
                        and <a href="https://www.amazon.com/Education-Value-Investor-Transformative-Enlightenment/dp/1137278811/">The education of a Value Investor by Guy Spier</a>. <a href="https://www.youtube.com/channel/UCA8P3Rgfjn0IFZL4bmrKbrg">Phil Town’s Youtube channel</a> is also very good, also check out Warren Buffet interviews on Youtube especially the ones from Berkshire Hathaway's annual shareholder meeting.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <strong>If Value Investing is so good why isn’t everyone doing it?</strong>
                      </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show">
                      <div className="card-body">
                        Value Investing is difficult to put into practice without the proper tools. We are building those tools, we want to change the way the average investor analyzes companies and investments.
                        Technology can help us make much better investing decisions.
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <strong>What algorithms are you using to rank companies on your website?</strong>
                      </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show">
                      <div className="card-body">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{rankingData}</ReactMarkdown>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <strong>Are you a financial Advisor?</strong>
                      </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show">
                      <div className="card-body">
                        No, we are a software company.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h5 className="mb-0">
                        <strong>How accurate is your data?</strong>
                      </h5>
                    </div>
                    <div id="collapseTwo" className="collapse show">
                      <div className="card-body">
                        We index our own data directly from the SEC Edgar system. We pull and index company SEC filings and then extract their financial data from XBRL documents every day. We try our best to ensure that all our data is accurate. However, the current version of our product is still a very early MVP (Minimum viable product). There may be some inaccuracies or limitations. We are working hard to ensure that all our data is accurate, and we are iterating very fast, fixing any issues or bugs that arise. We also want to thank you for using this very early version of our product. We encourage you to do your own research (using different sources) before making any investment decision. Our current product is a good starting point in your analysis to determine if a company will make a good investment in your portfolio. I can guarantee that our algorithms' data and analysis on the site are mostly accurate. I am a value investor, and I am already using it. We felt it was ready for public release while iterated and made improvements.
                        We also use data provided by <a href="https://financialmodelingprep.com/developer/docs/" target="_blank">Financial Modeling Prep</a> for Stock Quotes and other financial data.
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="mb-0">
                          <strong>Who is behind this?</strong>
                        </h5>
                      </div>
                      <div id="collapseTwo" className="collapse show">
                        <div className="card-body">
                          My name is Obi Akubue, I am a software engineer and value investor. I am also the founder of Decode Investing. You can reach me at <a href="mailto:obi@decodeinvesting.com">obi@decodeinvesting.com</a>.
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="headingTwo">
                        <h5 className="mb-0">
                          <strong>How can I support the community?</strong>
                        </h5>
                      </div>
                      <div id="collapseTwo" className="collapse show">
                        <div className="card-body">
                          Join us on reddit <a target="_blank" href="https://www.reddit.com/r/DecodeInvesting">/r/DecodeInvesting/</a> and <a target="_blank" href="https://www.reddit.com/r/EarningsCalls/">/r/EarningsCalls/</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTopButton />
    </div>
  );
}

const rankingData = `
Decode Investing employs a robust algorithm to auto-analyze all US public companies, ranking them based on their historical fundamentals over a 10-year period. This analysis aims to provide an estimated valuation for each stock using the company’s financial history.

#### Daily Leaderboard

Each day, the site generates a leaderboard showcasing the highest-ranked US public companies according to their fundamentals. This list is updated daily as new financial records (10-Ks, 10-Qs) are indexed and analyzed. You can view the leaderboard [here](https://www.decodeinvesting.com/leaderboard).

#### Analytical Process

The algorithm evaluates companies through various steps to generate a comprehensive value score, which serves as an overall rating of the business’s fundamentals. The value score is composed of the ROIC score, debt score, and moat score.

**1. ROIC Score**
   - Assesses the company’s Return on Invested Capital (ROIC) over the past ten years.
   - Each year is individually scored. A year with ROIC of 10% or above receives a perfect score.
   - The overall ROIC score is the mean of all yearly scores.

**2. Debt Score**
   - Measures the effectiveness of the company’s debt management.
   - Calculated from the debt payoff value, which is the time required to pay off current long-term debt using free cash flow.
   - A perfect debt score is achieved if long-term debt is zero.

**3. Management Score**
   - Represents the management’s performance, combining 80% of the ROIC score and 20% of the debt score.

**4. Moat Score**
   - Evaluates the company's competitive advantage through historical CAGR growth rates, including revenue, operating cash flow, and net income.
   - A perfect moat score requires consistent growth rates of 10% or above over one, three, five, seven, and ten years.

**5. Value Score**
   - Represents the overall fundamentals of a company, combining 50% moat score and 50% management score.

#### Leaderboard Details

The ranking system follows Rule One investing principles. Companies on the leaderboard must have a value score between 100% and 90% and at least five years of financial history.

#### Margin-Of-Safety Price

A fair value and margin-of-safety price are calculated using a simplified DCF method. This includes:

- An estimate of the 10-year growth rate.
- Future PE of the business.
- Current EPS (ttm).

The default growth rate is capped at 20% to prevent overly optimistic assumptions.

#### Payback Time

Payback time measures how long it will take to recoup investment capital from free cash flow:

- Calculated by projecting free cash flow growth until it equals the market cap.
- A payback time of 10 years or less is ideal, with 5 years being an extreme bargain.

For more detailed insights, check out [How Decode Investing's Ranking Algorithm Works: A Deep Dive 🚀](https://new.reddit.com/r/DecodeInvesting/comments/1erhv2k/how_decode_investings_ranking_algorithm_works_a/) and [How to calculate the true value of a business](https://decode-investing.medium.com/decode-investing-part-3-how-to-calculate-the-true-value-of-a-business-700dbbd0b728).

This algorithm provides a powerful tool for analyzing and ranking public companies, helping investors make more informed decisions. Feel free to explore the leaderboard and leverage these insights for your investment strategies!
`
